import { render, staticRenderFns } from "./asgctPC.vue?vue&type=template&id=3e8455d4&scoped=true"
import script from "./asgctPC.vue?vue&type=script&lang=js"
export * from "./asgctPC.vue?vue&type=script&lang=js"
import style0 from "./asgctPC.vue?vue&type=style&index=0&id=3e8455d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8455d4",
  null
  
)

export default component.exports